import React from "react";
import Home from "../components/Home.jsx";
import SEO from "../components/SEO";
const HomePage = () => {
    return (
        <>
            <SEO 
                page="home"
                customMeta={{
                    title: "Home - Shape Shifting Mastery",
                    description: "Transform your body and life with Shape Shifting Mastery. Expert guidance in body transformation and personal development.",
                    keywords: "shape shifting, body transformation, personal development, fitness transformation",
                    ogTitle: "Shape Shifting Mastery - Transform Your Body & Life",
                    ogDescription: "Begin your transformation journey with expert guidance and proven techniques."
                }}
            />
            <Home />
        </>
    );
};
export default HomePage;
